/* @flow weak */
import React from 'react';
import BoxBody from 'components/BoxBody.jsx';
import Form from 'components/Form.jsx';
import Link from 'components/Link.jsx';
import FormInput from 'components/FormInput.jsx';
import DialogContent from 'components/DialogContent.jsx';
import ToastActions from 'actions/ToastActions';
import DeviceActions from 'actions/DeviceActions';
import Button from 'components/Button.jsx';
import BoxFooter from 'components/BoxFooter.jsx';

import './styles/LinkSmsVerificationCodeBox.scss';

class LinkSmsVerificationCodeBox extends React.Component {
  static propTypes = {
    token: React.PropTypes.string.isRequired,
    onDone: React.PropTypes.func.isRequired,
    onResend: React.PropTypes.func.isRequired,
    phoneNumber: React.PropTypes.string,
    footer: React.PropTypes.object,
    successMessage: React.PropTypes.string,
  };

  onResend = () => {
    // FIXME: children because FormInput are wrapped by doWhileMounted
    this.refs.code.refs.children.changeValue('');
    this.props.onResend();
  };

  submit = (form) => {
    const onSuccess = (device) => {
      this.props.onDone(device);
      ToastActions.showSuccessToast(
        this.props.successMessage || 'Mobile phone linked to Remind'
      );
    };

    const onError = () => {
      ToastActions.showErrorToast(
        'Please enter a valid code.'
      );
    };

    DeviceActions
      .createOutboundDevice(this.props.token, form.code)
      .then(onSuccess, onError);
  };

  render() {
    const subtext = this.props.phoneNumber ?
     `Please enter the 4-digit code sent to ${this.props.phoneNumber}.` :
     'Please enter the 4-digit code sent to your phone.';

    return (
      <DialogContent
        size="small"
        full
        title={'Enter your code'}
        subtext={subtext}
        {...this.props}>
        <BoxBody divided>
          <div className="LinkSmsVerificationCodeBox">
            <Form onValidSubmit={this.submit}>
              <FormInput
                autofocus
                ref="code"
                className="LinkSmsVerificationCodeBox-Input"
                name="code"
                size="large"
                type="text"
              />
              <Button
                className="LinkSmsVerificationCodeBox-Submit"
                type="submit"
                eventElementName="LinkSmsVerificationCodeBox-Submit">
                Submit
              </Button>
            </Form>
          </div>
        </BoxBody>
        <BoxFooter>
          Didn’t receive a code? <Link onClick={this.onResend}>Resend</Link>
          {this.props.footer ? ' ' : null}
          {this.props.footer}
        </BoxFooter>
      </DialogContent>
    );
  }
}

export default LinkSmsVerificationCodeBox;



// WEBPACK FOOTER //
// ./src/user/components/LinkSmsVerificationCodeBox.jsx